"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaqListingPage = void 0;
var react_dom_1 = __importDefault(require("react-dom"));
var react_1 = __importStar(require("react"));
var AccordionList_1 = require("./AccordionList");
var FaqListingPage = function (props) {
    var _a = (0, react_1.useState)([]), faqs = _a[0], setFaqs = _a[1];
    (0, react_1.useEffect)(function () {
        if (props.data) {
            var tempList = __spreadArray([], props.data, true);
            var mappedList = tempList.map(function (el) {
                var _a;
                return ({
                    Heading: (el === null || el === void 0 ? void 0 : el.Heading) || null,
                    Content: (el === null || el === void 0 ? void 0 : el.MainIntro) || null,
                    Url: ((_a = el === null || el === void 0 ? void 0 : el.Url) === null || _a === void 0 ? void 0 : _a.Path) || null,
                    ShowReadMoreLink: (el === null || el === void 0 ? void 0 : el.ShowReadMoreLink) || false
                });
            });
            setFaqs(mappedList);
        }
    }, [props === null || props === void 0 ? void 0 : props.data]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AccordionList_1.AccordionList, { accordionList: faqs })));
};
exports.FaqListingPage = FaqListingPage;
var renderApp = function () {
    var _a;
    var nodeId = "index-faq-list-root";
    var appRootNode = document.getElementById(nodeId);
    var props = {};
    if (!appRootNode) {
        console.warn("Cannot find node with ID '".concat(nodeId, "'. The React app cannot be rendered."));
        return;
    }
    try {
        var dataString = (_a = appRootNode.getAttribute("data-list")) !== null && _a !== void 0 ? _a : "{}";
        props.data = JSON.parse(dataString);
    }
    catch (e) {
        console.error("Failed to parse props data", e);
    }
    react_dom_1.default.render(react_1.default.createElement(exports.FaqListingPage, props), appRootNode);
};
renderApp();
